import { Injectable }    from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { Request } from '../../../entity/request';


@Injectable()
export class AdditionalInformationService {

    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService) { }

    getAdditionalInformation(productClassCode: string) {
        return this.http.get(environment.apiUrl + 'site-api/list/additional_information?productClass=' + productClassCode,  {headers: this.headers})
        .map(res => {
          return res.json();
        })
        .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/analysis/additional-information/additional-information.service.ts